// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { app } from '../../../../../app';

app.factory('ShareAnAdditionalEmailAccount', modal);

/** @ngInject */
function modal($uibModal) {

    return function () {

        return $uibModal.open({
            templateUrl: require('./share-an-additional-email-account.html'),
            controller,
        }).result;

        /** @ngInject */
        function controller(
            $rootScope,
            $scope,
            $state,
            Alert,
            $translate,
            $uibModalInstance,
            CompanyUser,
            UserAccounts,
        ) {
            $scope.cancel = function () {
                $uibModalInstance.dismiss();
            };
            $scope.step = "step1";
            const companyId = $state.params.companyId;
            $scope.userDirectoriesHref = $state.href('company.user-directories');
            
            $scope.checkUserAccountType = function() {
                $scope.showNoUserErrorInstructions = false;
                var username = $scope.username;
                $scope.message = null;
                if($scope.username){
                    UserAccounts.getSharedEmailAccountType({
                        companyId : companyId,
                        username : username
                    }, function(data) {
                        if (data.accountType == "INTERNAL_EMAIL") {
                            $scope.step = 'step_INTERNAL_EMAIL';
                            $scope.assignedCompanyUser = data.companyUser;
                        } else if (data.accountType == "SHARED_EMAIL") {
                            $scope.step = 'step_SHARED_EMAIL';
                            $scope.alreadySharedTekst = $translate.instant("sharing_center.company_email_account_is_already_shared", {username: username});
                        } else {
                            $scope.message = $translate.instant("sharing_center.no_company_email_account_found_for")+": "+username;
                            $scope.showNoUserErrorInstructions = true;
                        }
                    }, function(response) {
                        if(response.data.serviceErrorCode == "ERR_100802"){
                            $scope.message = $translate.instant("sharing_center.no_company_email_account_found_for")+": "+username;
                            $scope.showNoUserErrorInstructions = true;
                        }else{
                            $scope.message = response.data.message;
                        }
                    });
                }
            }
            
            $scope.manageAccount = function(username){
                $state.go('company.sharing-center.shared-accounts.manage', {username});
                $uibModalInstance.dismiss();
            }
            
            $scope.identifyUser = function() {
                $scope.message = null;
                    $scope.userIdentifier = $scope.newUserIdentifier;

                    if ($scope.userIdentifier == $scope.currentSaaspassId) {
                        $scope.successResult = false;
                        $scope.showVerification = false;

                        $scope.message = 'groups_users.user_is_the_same';
                    } else if ($scope.userIdentifier == $scope.currentEmailAddress) {
                        $scope.successResult = false;
                        $scope.showVerification = false;

                        $scope.message = 'groups_users.user_email_is_the_same';
                    } else {
                        CompanyUser.identifyCompanyUser({
                            companyId : companyId,
                            uid : encodeURIComponent($scope.userIdentifier)
                        }, function(data) {
                            if ((data.id && data.id == $scope.currentCompanyUserId) ||
                                    (data.saaspassUser && data.saaspassUser.id == $scope.currentSaaspassId)) {
                                $scope.successResult = false;
                                $scope.showVerification = false;

                                $scope.message = 'groups_users.user_is_the_same';
                            } else {
                                $scope.successResult = true;
                                $scope.showVerification = false;
                                $scope.companyUser = data;

                                $scope.message = 'groups_users.user_found';
                            }
                        }, function(response) {
                            $scope.successResult = false;
                            $scope.companyUser = null;

                            $scope.showVerification = $scope.enableVerification && !$scope.successResult
                                    && $rootScope.emailPattern.test($scope.userIdentifier);

                            if (response.status == 404) {
                                $scope.message = 'groups_users.user_not_found';
                            } else {
                                $scope.message = response.data.message;
                            }
                        });
                    }
            }
        
            $scope.share = function(saaspassId){
                var username = $scope.username;
                if($scope.isSendingRequest){
                    return;
                }
                $scope.isSendingRequest = true;
                
                var param = {
                        companyId: companyId
                }
                var dataReq = {
                        username: username,
                        companyUser: $scope.companyUser
                }
                
                UserAccounts.createSharedUserAccount(param, dataReq, function(data){
                    $scope.userAccount = data;
                    $scope.username = data.username;
                    $scope.newAccount = data;
                    const key = 'groups_users.added_active_account_SHARED_EMAIL';
                    const variables = {saaspassId};
                    $state.reload($state.current)
                        .then(() => Alert('success', key, variables))
                }, function(error){
                    $scope.isSendingRequest=false;
                })
                
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-accounts/share-an-additinal-email-account/share-an-additional-email-account.modal.js